import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle } from '@fortawesome/pro-solid-svg-icons';

import { formatPercent } from 'helpers/formatters/number_formats';
import EnvelopeSVG from 'otter_icons/standalone/envelope.svg';
import EmptyState from 'components/project/empty_state';
import EmailDonut, { OPENED_COLOR, CLICKED_COLOR } from '../email_donut';
import EmailTable from '../email_table';
import Card from './card';

export default class Email extends React.Component {
  static propTypes = {
    emailsClicked: PropTypes.number,
    emailsDelivered: PropTypes.number,
    emailsOpened: PropTypes.number,
    fullScreen: PropTypes.bool,
    loadingMetrics: PropTypes.bool.isRequired,
    sentMessages: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      sentAt: PropTypes.string.isRequired,
      subject: PropTypes.string.isRequired,
      numDelivered: PropTypes.number,
      numUniqueOpens: PropTypes.number,
      numClicks: PropTypes.number
    }))
  }


  renderPreview() {
    const { emailsOpened, emailsClicked, emailsDelivered } = this.props;

    return (
      <div className="email-preview">
        <div className="mb-4 text-center email-chart-legend">
          <span className="mr-4" name="emails-opened">
            <FontAwesomeIcon className="emails-opened-icon mr-2" color={OPENED_COLOR} icon={faCircle} size="xs" />
            {formatPercent(emailsOpened / emailsDelivered)} Opened
          </span>
          <span name="emails-clicked">
            <FontAwesomeIcon className="emails-clicked-icon mr-2" color={CLICKED_COLOR} icon={faCircle} size="xs" />
            {formatPercent(emailsClicked / emailsDelivered)} Clicked
          </span>
        </div>
        <EmailDonut
          className="overview"
          emailsClicked={emailsClicked}
          emailsDelivered={emailsDelivered}
          emailsOpened={emailsOpened}
        />
      </div>
    );
  }

  renderDonuts() {
    const { emailsClicked, emailsDelivered, emailsOpened } = this.props;
    return ['deliveries', 'opens', 'clicks'].map(type => (
      <EmailDonut
        emailsClicked={emailsClicked}
        emailsDelivered={emailsDelivered}
        emailsOpened={emailsOpened}
        key={type}
        type={type}
      />
    ));
  }

  renderDetail() {
    return (
      <div className="email-details">
        <div className="visible-xs">{this.renderDonuts()}</div>
        <div className="details w-100">
          <div className="hidden-xs sidebar border-right mr-5">{this.renderDonuts()}</div>
          <EmailTable messages={this.props.sentMessages} />
        </div>
      </div>
    );
  }

  renderBody() {
    if (this.props.emailsDelivered === 0) {
      return (
        <EmptyState
          imageSrc={EnvelopeSVG}
          message="No marketing emails have been sent yet."
          subMessage="Email metrics will be shown here once an email has been sent for this property."
        />
      );
    }

    if (!this.props.fullScreen) return this.renderPreview();

    return this.renderDetail();
  }

  render() {
    return (
      <Card
        {...this.props}
        loading={this.props.loadingMetrics}
        subtitle="Overview of email activity"
        title="Email Campaigns"
      >
        {this.renderBody()}
      </Card>
    );
  }
}
